import { useEffect } from "react";
import { useGlobalState } from "../../GlobalContext";
import {
  DefaultTitleBase,
  formatPageTitle,
} from "../hooks/usePageTitle";

// Names the tab after the organisation and the page, once the initial state is bound
// so the default title never shows before the organisation resolves.
export function usePortalPageTitle(title) {
  const { initialStateBound, organisation } = useGlobalState();

  useEffect(() => {
    if (!initialStateBound) {
      return;
    }

    document.title = formatPageTitle(organisation || DefaultTitleBase, title);
  }, [initialStateBound, organisation, title]);
}

export default usePortalPageTitle;
